import { classes } from "constants/common/formConstants";
import { booleanOptions } from "constants/common/formConstants";
import { locais } from "constants/common/formConstants";
import { estados } from "constants/common/formConstants";
import { toMakeReports } from "constants/goldenRules/goldenRules";

export const tableFilterVariables = ({ owners = [] }) => [
    {
        fieldId: 'owner',
        label: 'Owner',
        type: 'select',
        width: "226px",
        options: [{ label: 'Todos utilizadores', value: "todos" }, ...owners]
    },
    {
        fieldId: 'classe',
        name: 'Classe',
        type: 'select',
        width: "226px",
        label: "Classe",
        options: [{ label: 'Todas classes', value: "todos" }, ...classes]
    },
    {
        fieldId: 'stopCard',
        type: 'select',
        width: "226px",
        label: "Stop card",
        options: [{ label: 'Todos', value: "todos" }, ...booleanOptions]
    },
    {
        fieldId: 'local',
        name: 'Local',
        type: 'select',
        width: "226px",
        label: "Local",
        options: [{ label: 'Todos sites', value: "todos" }, ...locais]
    },
    {
        fieldId: 'Situacao',
        type: 'select',
        width: "226px",
        label: "Situação",
        options: [{ label: 'Todos estados', value: "todos" }, ...estados]
    },
    // {
    //     fieldId: 'golden_rule',
    //     name: 'Golden_Rule',
    //     label: "Golden Rule",
    //     width: "226px",
    //     type: 'select',
    //     options: [{ label: 'Todas regras', value: "todos" }, ...toMakeReports.map((x) => { return { label: x.sectionName, value: JSON.stringify(x.rules) } })]
    // },
    {
        fieldId: 'data',
        name: 'Data',
        type: 'dateRange'
    },
]